import React, { useState } from "react";
import { BsPaperclip, BsArrowRight } from "react-icons/bs";
import "./index.scss";
import cont from "../../assets/images/cont.png";
import { FlechBtn } from "../../assets/icons/FlechBtn";
import { showErrorToaster } from "../toaster/error";
import { showSuccessToaster } from "../toaster/success";
import DevisService from "../../services/devis/devis.service";
const devisService = new DevisService();
const ContactForm = () => {
  const [form, setForm] = useState({
    nom: "",
    email: "",
    tel: "",
    typeProjet: "Isolation",
    message: "",
    file: null,
    accept: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setForm({
      ...form,
      [name]:
        type === "checkbox" ? checked : type === "file" ? files[0] : value,
    });
  };
  console.log("form", form);
  const [formErrors, setFormErrors] = useState();
  let label = {
    nom: "Nom et prenom",
    email: "email",
    tel: "telephone",
    typeProjet: "Type Projet",
    message: "message",
    file: "file",
    accept: "accept",
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let error = false;
    let errors = {};

    // Validation des champs requis
    if (!form?.nom || form.nom.trim() === "") {
      error = true;
      errors["nom"] = "Champ obligatoire";
    }

    if (!form?.email || form.email.trim() === "") {
      error = true;
      errors["email"] = "Champ obligatoire";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(form.email)) {
        error = true;
        errors["email"] = "Email invalide";
      }
    }

    if (!form?.tel || form.tel.trim() === "") {
      error = true;
      errors["tel"] = "Champ obligatoire";
    } else {
      const telRegex = /^[0-9\s()+-]{8,20}$/;
      if (!telRegex.test(form.tel)) {
        error = true;
        errors["tel"] = "Numéro de téléphone invalide";
      }
    }

    if (!form?.typeProjet || form.typeProjet.trim() === "") {
      error = true;
      errors["typeProjet"] = "Champ obligatoire";
    }

    if (!form?.message || form.message.trim() === "") {
      error = true;
      errors["message"] = "Champ obligatoire";
    }

    if (!form?.accept) {
      error = true;
      errors["accept"] = "Vous devez accepter les conditions";
    }

    // Définir les erreurs dans le state
    setFormErrors(errors);

    // Affichage des erreurs dans les toasts
    if (error) {
      Object.keys(errors).forEach((item) => {
        showErrorToaster(errors[item]); // ✅ Utilise le message exact
      });
      return; // ⛔ Ne continue pas si erreurs
    } else {
      try {
        // Appeler le service pour envoyer le devis
        const formToSend = new FormData();
        formToSend.append("nom", form.nom);
        formToSend.append("email", form.email);
        formToSend.append("tel", form.tel);
        formToSend.append("typeProjet", form.typeProjet);
        formToSend.append("message", form.message);
        formToSend.append("accept", form.accept);

        formToSend.append("file", form.file);

        await devisService.addDevis(formToSend); // à adapter selon ton service

        showSuccessToaster("Demande de devis envoyée avec succès");

        setForm({
          nom: "",
          email: "",
          tel: "",
          typeProjet: "Isolation",
          message: "",
          file: null,
          accept: false,
        });

        setFormErrors({});
      } catch (error) {
        showErrorToaster(
          error.response?.data?.message ||
            "Une erreur est survenue, veuillez réessayer."
        );
      }
    }
  };

  return (
    <div className="contact-form-section  my-5">
      <div className="row align-items-center">
        <div className="col-lg-6 mb-4 mb-lg-0">
          <h4 className="mb-4 contact-text-primary ">
            Veuillez remplir le formulaire de contact
          </h4>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Nom</label>
              <input
                type="text"
                name="nom"
                placeholder="Tapez votre nom"
                className="form-control mb-3"
                value={form.nom}
                onChange={handleChange}
              />
            </div>{" "}
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                placeholder="Tapez votre email"
                className="form-control mb-3"
                value={form.email}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Téléphone</label>
              <input
                type="tel"
                name="tel"
                placeholder="Tapez votre téléphone"
                className="form-control mb-3"
                value={form.tel}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Type de projet</label>
              <select
                name="typeProjet"
                className="form-select mb-3"
                value={form.typeProjet}
                onChange={handleChange}>
                <option>Isolation</option>
                <option>Rénovation</option>
                <option>Plomberie</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Message</label>
              <textarea
                name="message"
                rows="4"
                placeholder="Tapez votre message"
                className="form-control mb-3"
                value={form.message}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Joindre un fichier</label>
              <div className="upload-box mb-3">
                <label className="upload-label">
                  <BsPaperclip className="me-2" />
                  Cliquez pour joindre un fichier
                  <input
                    type="file"
                    name="file"
                    onChange={handleChange}
                    className="d-none"
                  />
                </label>
              </div>
            </div>
            <div className="form-check mb-4">
              <input
                type="checkbox"
                name="accept"
                className="form-check-input"
                checked={form.accept}
                onChange={handleChange}
                id="acceptPolicy"
              />
              <label className="form-check-label" htmlFor="acceptPolicy">
                J’accepte la politique de confidentialité
              </label>
            </div>
            <button className="btn btn-primary w-100 d-flex justify-content-center align-items-center gap-2">
              Envoyer <FlechBtn />
            </button>
          </form>
        </div>
        <div className="col-lg-6 text-center">
          <img
            src={cont}
            alt="Agent service client"
            className="contact-form-image img-fluid"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
